document.addEventListener('DOMContentLoaded', () => {

  const menu =
    document.querySelector('[data-nmh]');

  if (!menu) return;


  const trigger =
    menu.querySelector('[data-nmh-trigger]');

  const overlay =
    menu.querySelector('[data-nmh-overlay]');

  const close =
    menu.querySelector('[data-nmh-close]');

  const search =
    menu.querySelector('[data-nmh-search]');


  /* ==========================================
     HELPER
  ========================================== */

  function directChild(parent, selector) {

    if (!parent) return null;

    return Array
      .from(parent.children)
      .find(child =>
        child.matches?.(selector)
      ) || null;

  }


  /* ==========================================
     NÍVEL 3 - FECHAR
  ========================================== */

  function closeNestedSubmenu(item) {

    if (!item) return;


    const toggle =
      directChild(
        item,
        '[data-nested-submenu-toggle]'
      );


    const submenu =
      directChild(
        item,
        '[data-nested-submenu]'
      );


    if (!submenu) return;


    if (toggle) {

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );


      toggle.textContent =
        '+';

    }


    submenu.hidden =
      true;


    item.classList.remove(
      'is-open'
    );

  }


  function closeAllNestedSubmenus(scope = menu) {

    scope
      .querySelectorAll(
        '.nmh__submenu-item.has-submenu'
      )
      .forEach(
        closeNestedSubmenu
      );

  }


  /* ==========================================
     NÍVEL PRINCIPAL - FECHAR
  ========================================== */

  function closeTopSubmenu(item) {

    if (!item) return;


    const toggle =
      directChild(
        item,
        '[data-submenu-toggle]'
      );


    item.classList.remove(
      'is-open'
    );


    if (toggle) {

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );

    }


    closeAllNestedSubmenus(
      item
    );

  }


  function closeAllTopSubmenus(
    exception = null
  ) {

    menu
      .querySelectorAll(
        '.nmh__item.has-submenu'
      )
      .forEach(item => {

        if (item === exception) {
          return;
        }


        closeTopSubmenu(
          item
        );

      });

  }


  /* ==========================================
     DRAWER
  ========================================== */

  function openMenu() {

    menu.classList.add(
      'is-open'
    );


    document.body.style.overflow =
      'hidden';

  }


  function closeMenu() {

    menu.classList.remove(
      'is-open'
    );


    document.body.style.overflow =
      '';


    closeAllTopSubmenus();

    closeAllNestedSubmenus();

  }


  trigger?.addEventListener(
    'click',
    openMenu
  );


  close?.addEventListener(
    'click',
    closeMenu
  );


  overlay?.addEventListener(
    'click',
    closeMenu
  );


  document.addEventListener(
    'keydown',
    event => {

      if (
        event.key === 'Escape'
      ) {

        closeMenu();

      }

    }
  );


  /* ==========================================
     PESQUISA
  ========================================== */

  search?.addEventListener(
    'click',
    () => {

      closeMenu();


      const themeSearch =
        document.querySelector(
          'search-button button'
        );


      if (!themeSearch) return;


      themeSearch.click();

    }
  );


  /* ==========================================
     NÍVEL PRINCIPAL
     EX: PRODUTOS
  ========================================== */

  menu
    .querySelectorAll(
      '.nmh__item.has-submenu'
    )
    .forEach(item => {


      const link =
        directChild(
          item,
          '[data-submenu-link]'
        );


      const toggle =
        directChild(
          item,
          '[data-submenu-toggle]'
        );


      const submenu =
        directChild(
          item,
          '[data-submenu]'
        );


      if (!submenu) return;


      function toggleTopSubmenu(event) {

        event.preventDefault();

        event.stopPropagation();


        const isOpen =
          item.classList.contains(
            'is-open'
          );


        closeAllTopSubmenus(
          item
        );


        if (isOpen) {

          closeTopSubmenu(
            item
          );

          return;

        }


        item.classList.add(
          'is-open'
        );


        toggle?.setAttribute(
          'aria-expanded',
          'true'
        );

      }


      /*
       * CLICAR NO NOME
       * abre submenu em vez de navegar
       */

      link?.addEventListener(
        'click',
        toggleTopSubmenu
      );


      /*
       * CLICAR NO +
       */

      toggle?.addEventListener(
        'click',
        toggleTopSubmenu
      );

    });


  /* ==========================================
     NÍVEL 3
     EX: LINHAS
  ========================================== */

  menu
    .querySelectorAll(
      '.nmh__submenu-item.has-submenu'
    )
    .forEach(item => {


      const link =
        directChild(
          item,
          '[data-nested-submenu-link]'
        );


      const toggle =
        directChild(
          item,
          '[data-nested-submenu-toggle]'
        );


      const submenu =
        directChild(
          item,
          '[data-nested-submenu]'
        );


      if (!submenu) return;


      /* ======================================
         ESTADO INICIAL
      ====================================== */

      submenu.hidden =
        true;


      item.classList.remove(
        'is-open'
      );


      if (toggle) {

        toggle.setAttribute(
          'aria-expanded',
          'false'
        );


        toggle.textContent =
          '+';

      }


      /* ======================================
         ABRIR / FECHAR
      ====================================== */

      function toggleNestedSubmenu(event) {

        /*
         * ESSENCIAL:
         *
         * impede o link "Linhas"
         * de redirecionar para a coleção.
         */

        event.preventDefault();

        event.stopPropagation();


        const isOpen =
          item.classList.contains(
            'is-open'
          );


        /*
         * fecha outros submenus internos
         * do mesmo grupo
         */

        const parent =
          item.parentElement;


        if (parent) {

          Array
            .from(parent.children)
            .filter(child =>
              child.classList?.contains(
                'nmh__submenu-item'
              )
            )
            .forEach(sibling => {

              if (
                sibling !== item &&
                sibling.classList.contains(
                  'has-submenu'
                )
              ) {

                closeNestedSubmenu(
                  sibling
                );

              }

            });

        }


        /* FECHAR */

        if (isOpen) {

          closeNestedSubmenu(
            item
          );

          return;

        }


        /* ABRIR */

        item.classList.add(
          'is-open'
        );


        submenu.hidden =
          false;


        if (toggle) {

          toggle.setAttribute(
            'aria-expanded',
            'true'
          );


          toggle.textContent =
            '−';

        }

      }


      /*
       * CLICAR NO NOME
       *
       * LINHAS
       * PARTES DE CIMA
       * PARTES DE BAIXO
       *
       * Se possuir submenu,
       * NÃO navega.
       * Abre o próximo nível.
       */

      link?.addEventListener(
        'click',
        toggleNestedSubmenu
      );


      /*
       * CLICAR NO +
       */

      toggle?.addEventListener(
        'click',
        toggleNestedSubmenu
      );

    });

});